import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  usersPage: {
    '.MuiDataGrid-row': {
      '.contextMenuBtn': {
        opacity: 0.3
      },
      '&:hover .contextMenuBtn': {
        opacity: 1
      }
    }
  },
  usersPagePaper: {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  searchBox: {
    backgroundColor: 'var(--mui-palette-background-elevation1)',
    padding: '0.5rem 1rem',
    borderBottom: 'solid 1px var(--mui-palette-border-light)',
    '.quickSearch': {
      maxWidth: '20rem'
    }
  },
  tableWidget: {
    backgroundColor: theme.vars.palette.background.elevation2,
    '.MuiDataGrid-columnHeader': {
      backgroundColor: theme.vars.palette.background.elevation2
    }
  }
}));

export default useStyles;
